import { cn } from '@/lib/utils';

export function ProgressiveQuestionReveal({ children, className }: React.ComponentProps<'div'>) {
  return (
    <div className={cn('animate-in fade-in slide-in-from-top-2 duration-200', className)}>
      {children}
    </div>
  );
}
